import {
  COUPON_AFFECTED_STATIC_CACHE_KEYS,
  PDP_CACHE_KEY_PREFIXES,
} from '~/models/AsyncDataKeys.model';

export const general_clearCouponAffectedCaches = () => {
  clearNuxtData((key) => {
    if (
      (COUPON_AFFECTED_STATIC_CACHE_KEYS as readonly string[]).includes(key)
    ) {
      return true;
    }
    return PDP_CACHE_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
  });
};
